import { REDUCER_IS_LOADING_PREFIX, REDUCER_HAS_ERRORED_PREFIX, REDUCER_SUCCESS_PREFIX , REDUCER_RESET_PREFIX} from '../constants';

export function globalReducer(reducerName = '', initialState = { success: {}, loading: false, error: false }) {
  return function(state = initialState, action) {
    switch (action.type) {
      case `${REDUCER_SUCCESS_PREFIX}${reducerName}`:
        return { ...state, success: action.payload };
      case `${REDUCER_IS_LOADING_PREFIX}${reducerName}`:
        return { ...state, loading: action.payload };
      case `${REDUCER_HAS_ERRORED_PREFIX}${reducerName}`:
        return { ...state, error: action.payload };
      case `${REDUCER_RESET_PREFIX}${reducerName}`:
          return initialState;
      default:
        return state;
    }
  }
}